// Login.js

import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import logo from '../images/login_ppms.png';
import { useAuth } from '../contexts/CommonCtx';
//import { useTheme } from "@emotion/react";
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
//import Paper from '@mui/material/Paper';
//import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
//import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';

const Copyright = (props) => {
    return (
        <Typography variant="body2" color="text.secondary" align="center" fontWeight="normal" {...props} sx={{ fontSize: '0.6rem' }}>
            {'Copyright © '}
            <Link color="inherit" href="https://mingspm.com/">
                MingsPM
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
};

const Login = (props) => {
    //console.log('login_props', props);

    //const theme = useTheme();

    const { ip, user, setUser, setMl, ppms, port, setMode } = useAuth();
    //console.log('login_user', user);

    const [ id, setId ] = useState('');
    const [ pw, setPw ] = useState('');

    //const handleId = (e) => {
    //    setId(e.target.value);
    //}

    //const handlePw = (e) => {
    //    setPw(e.target.value);
    //}

    const handleLogin = async(e) => {
        e.preventDefault();

        const formdata = new FormData(e.currentTarget);
        const login_id = formdata.get('id');
        const login_pw = formdata.get('pw');
        //console.log({ id: fromdata.get('id'), pw: formdata.get('pw') });

        setId(login_id);
        setPw(login_pw);
        //console.log('form', login_id, login_pw, id, pw);

        let data = {
            id: id,
            pw: pw,
            ip: ip
        };
        //data = {
        //    id: login_id, //id,
        //    pw: login_pw, //pw,
        //    ip: ip
        //};
        data = new URLSearchParams({
            id: login_id, //id,
            pw: login_pw, //pw,
            ip: ip
        });
        //console.log('data', data);

        try {
            //const res = await axios.post(`${ppms}:${port}/appms/login`, data, { 'Content-Type': 'application/json', withCredentials: true });
            const res = await axios.post(`${ppms}:${port}/appms/login`, data, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', withCredentials: true });
            //console.log('login_res', res);

            // set user info
            setUser(res.data);
            
            const r = await axios.get(`${ppms}:${port}/appms/ml/${res.data.lang}`, { withCredentials: true });
            //console.log('ml_res', r);
            // set language
            setMl(r.data);

            // redirect main
            //const navigate = useNavigate();
            //navigate('/');
            setMode('MainMenu');
            return <Navigate replace to='/' />;

        } catch (err) {
            console.log(err);
        }

        /*
        axios.post(`${ppms}:${port}/appms/login`, data, { 'Content-Type': 'application/json', withCredentials: true })
        .then((res) => {
            //console.log('res', res);

            // set user info
            setUser(res.data);
            
            const res = await axios.get(`${ppms}:${port}/appms/ml/${lang}`, { withCredentials: true });
            //console.log('lang_res', res);
            // set language
            setMl(res.data);

            // redirect main
            //const navigate = useNavigate();
            //navigate('/');
            return <Navigate replace to='/' />;

            //const user = {
            //    type: 'appms_login',
            //    subtype: 'user',
            //    note: ip,
            //    id: res.data.user_id,
            //    name: res.data.user_name,
            //    ip: ip
            //};
            //axios.post(`${ppms}:${port}/appms/adt`, user, { 'Content-Type': 'application/json', withCredentials: true });
        })
        .catch((err) => console.log(err));
        */

        /*
        const data = {
            id: id,
            pw: pw,
            ip: ip
        };
        fetch('/login', {
            method: 'post',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then((res) => res.json())
        .then((json) => {            
            //console.log('json', json);

            const user = {
                type: 'appms_login',
                subtype: 'user',
                note: ip,
                id: json.user_id,
                name: json.user_name,
                ip: ip
            };
            fetch('/adt', {
                method: 'post',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify(user),
            });
        });
        */
    };

    useEffect(() => {
    }, []);

    if (user.user_id) return <Navigate replace to='/' />;

    const ContainerLogin = styled(Container)(({theme}) => ({
        display: 'flex',
        m: 0,
        p: 0,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f8ff',
        //background: theme.palette.grey[50],
    }));
    const CardLogin = styled(Card)(({theme}) => ({
        display: 'flex',
        flexDirection: {
            xs: 'column', // mobile
            sm: 'row', // tablet and up
        },
        //m: 0,
        //p: 0,
        width: '80%',
        height: '70vh',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 10,
        background: theme.palette.white,
        boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    }));
    const BoxLogin = styled(Box)(({theme}) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        //alignSelf: 'center',
        //justifyContent: 'center',
    }));
    const BoxLogo = styled(Box)(({theme}) => ({
        width: '100%',
        height: '25vh',
        //backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
        backgroundImage: `url(${logo})`,
        backgroundRepeat: 'no-repeat',
        backgroundColor: (t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    }));

    //<input type="text" name="id" placeholder="아이디" value={id} onChange={handleId} />
    //<input type="password" name="pw" placeholder="비밀번호" value={pw} onChange={handlePw} />
    //<button type="submit" onClick={handleLogin}>로그인</button>

    return (
        <ContainerLogin maxWidth="sm">
            <CardLogin variant="outlined">
                <BoxLogin sx={{ mt: 2, mb: 1, mx: 4 }}>
                    <BoxLogo sx={{ mx: 4 }} />
                    <Box component="form" noValidate onSubmit={handleLogin} sx={{ mt: 1, mb: 1 }}>
                        <TextField variant="standard" size="small" margin="dense" required fullWidth id="login-id" label="Login ID" name="id" autoComplete="id" autoFocus />
                        <TextField variant="standard" size="small" margin="dense" required fullWidth id="login-pw" label="Password" name="pw" type="password" autoComplete="current-password" />
                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                            Sign In
                        </Button>
                        {/*
                        <Grid container sx={{ justifyContent: "center" }}>
                            <Grid item sx={{ mx: 1 }}>
                                <Link href="#" variant="body2">
                                    {"Find password"}
                                </Link>
                            </Grid>
                            <Grid item sx={{ mx: 1 }}>
                                <Link href="#" variant="body2">
                                    {"Sign Up"}
                                </Link>
                            </Grid>
                        </Grid>
                        */}
                        <Copyright sx={{ mt: 2 }} />
                    </Box>
                </BoxLogin>
            </CardLogin>
        </ContainerLogin>
    );
};

export default Login;


